import { useQuery } from '@tanstack/react-query';
import { AssessmentSubmission, getAppointmentAssessmentsBySubmissionIds, getBatchAssessmentSubmissions } from '@uplift/api';
import { AssessmentKeys, Form } from '@uplift/types';
import { BaseQueryOpts } from './baseTypes';


export const useBatchAssessmentsSubmissions = (patientId?: string, submissionIds?: string[], opts?: BaseQueryOpts) => {
  return useQuery([ 'batch-assessment-submissions', patientId, submissionIds ], async () => {
    if (!patientId || !submissionIds?.length) {
      return { submissionById: {}, formById: {}, formIdToKey: {} };
    }

    const response = await getBatchAssessmentSubmissions(patientId, submissionIds);
    const submissionById = response.data?.submissions?.reduce((prev, curr) => ({ ...prev, [curr.submission.formSubmissionId]: curr }), {} as Record<string, AssessmentSubmission>) ?? {};
    const formById = response.data?.forms?.reduce((prev, curr) => ({ ...prev, [curr.formId]: curr }), {} as Record<string, Form>) ?? {};
    const formIdToKey = response.data?.formIdToKey.reduce((prev, curr) => ({ ...prev, [curr.formId]: curr.key }), {} as Record<string, AssessmentKeys>);

    return { submissionById, formById, formIdToKey };
  }, opts);
};

export const useAppointmentAssessmentsBySubmissionIds = (submissionIds: string[], opts?: BaseQueryOpts) => {
  return useQuery([ 'appointment-assessments-by-submission-ids', submissionIds ], async () => {
    if (!submissionIds?.length) {
      return [];
    }

    const response = await getAppointmentAssessmentsBySubmissionIds({ submission_ids: submissionIds });

    return response.data;
  }
  , opts);
};
